import { MdEmail, MdPhone, MdLocalPhone, MdMenu } from "react-icons/md";
import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp, FaDownload, FaCalendar } from "react-icons/fa";
import { useState, useRef, useEffect, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { mediaSource } from "../utilities/mediautilities";
import MenuItems from "./MenuItems.jsx";

const Header = () => {
    const { schoolDetails } = useContext(schoolContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            {/* Top Sub Header */}
            <div className="bg-primary text-xs sm:text-sm text-accent px-2 sm:px-4 py-1.5 sm:py-2">
                <div className="common-container flex flex-col sm:flex-row items-center sm:justify-between gap-2 w-full">
                    <div className="flex-1">
                        {(schoolDetails?.email ||
                            schoolDetails?.contact_number ||
                            schoolDetails?.telephone_number) && (
                                <div className="flex items-center flex-wrap justify-center sm:justify-start gap-2 sm:gap-6">
                                    {schoolDetails?.email && (
                                        <span className="flex items-center gap-1.5 sm:gap-2">
                                            <MdEmail className="text-base sm:text-lg flex-shrink-0" />
                                            <span>{schoolDetails.email}</span>
                                        </span>
                                    )}
                                    {schoolDetails?.contact_number && (
                                        <a
                                            href={`tel:+${schoolDetails.contact_number}`}
                                            className="flex items-center gap-1.5 sm:gap-2 hover:text-secondary"
                                        >
                                            <MdPhone className="text-base sm:text-lg flex-shrink-0" />
                                            <span>{schoolDetails.contact_number}</span>
                                        </a>
                                    )}
                                    {schoolDetails?.telephone_number && (
                                        <a
                                            href={`tel:+${schoolDetails.telephone_number}`}
                                            className="flex items-center gap-1.5 sm:gap-2 hover:text-secondary"
                                        >
                                            <MdLocalPhone className="text-base sm:text-lg flex-shrink-0" />
                                            <span>{schoolDetails.telephone_number}</span>
                                        </a>
                                    )}
                                </div>
                            )}
                    </div>
                    <div className="flex justify-end gap-2 flex-shrink-0">
                        <Link to="/calendar">
                            <FaCalendar className="text-base hover:text-secondary cursor-pointer" />
                        </Link>
                        {schoolDetails?.facebook && (
                            <a
                                href={schoolDetails.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-secondary transition-colors"
                                aria-label="Facebook"
                            >
                                <FaFacebook className="text-base sm:text-lg hover:text-secondary" />
                            </a>
                        )}
                        {schoolDetails?.instagram && (
                            <a
                                href={schoolDetails.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-secondary transition-colors"
                                aria-label="Instagram"
                            >
                                <FaInstagram className="text-base sm:text-lg hover:text-secondary" />
                            </a>
                        )}
                        {schoolDetails?.youtube && (
                            <a
                                href={schoolDetails.youtube}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-secondary transition-colors"
                                aria-label="YouTube">
                                <FaYoutube className="text-base sm:text-lg hover:text-secondary" />
                            </a>
                        )}
                        {schoolDetails?.whatsapp_number && (
                            <a
                                href={`https://wa.me/${schoolDetails.whatsapp_number}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-secondary transition-colors"
                                aria-label="WhatsApp"                            >
                                <FaWhatsapp className="text-base sm:text-lg hover:text-secondary" />
                            </a>
                        )}
                    </div>
                </div>
            </div>

            {/* Main Header */}
            <header className="bg-accent shadow-md sticky top-0 z-30 relative">
                <div className="common-container flex items-center justify-between py-4 px-4 relative">
                    <div className="flex items-center gap-4">
                        <img
                            src={mediaSource(schoolDetails?.logo?.fileUrl)}
                            alt="School Logo"
                            className="h-12 w-12 md:h-14 md:w-14 bg-white cursor-pointer"
                            onClick={() => navigate("/")}
                            onError={(e) => mediaSource(e)}
                        />
                        {(schoolDetails?.name || schoolDetails?.slogan) &&
                            <div className="flex flex-col leading-tight">
                                {schoolDetails?.name &&
                                    <span className=" md:text-xl font-bold text-primary">
                                        {schoolDetails?.name}
                                    </span>
                                }
                                {schoolDetails?.slogan &&
                                    <span className="text-[10px] md:text-xs text-primary font-medium">
                                        {schoolDetails?.slogan}
                                    </span>
                                }
                            </div>
                        }
                    </div>


                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center gap-6">
                        <MenuItems schoolDetails={schoolDetails} />
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden text-3xl text-primary hover:text-secondary transition-colors p-2"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                    >
                        <MdMenu />
                    </button>

                    {/* <button onClick={() => senddata()}>Send Data</button> */}

                    {/* Mobile Menu Overlay */}
                    <AnimatePresence>
                        {menuOpen && (
                            <>
                                {/* Backdrop */}
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    className="fixed inset-0 bg-black/50 z-40 md:hidden"
                                    onClick={() => setMenuOpen(false)}
                                />

                                {/* Mobile Menu Sidebar */}
                                <motion.div
                                    ref={menuRef}
                                    initial={{ x: '100%' }}
                                    animate={{ x: 0 }}
                                    exit={{ x: '100%' }}
                                    transition={{ type: 'tween', duration: 0.3 }}
                                    className="fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 md:hidden overflow-y-auto"
                                >
                                    {/* Menu Header */}
                                    <div className="bg-primary text-accent px-6 py-4 flex items-center justify-between border-b border-primary/20">
                                        <h3 className="text-lg font-bold">Menu</h3>
                                        <button
                                            onClick={() => setMenuOpen(false)}
                                            className="text-2xl hover:text-secondary transition-colors"
                                            aria-label="Close menu"
                                        >
                                            &times;
                                        </button>
                                    </div>

                                    {/* Menu Items */}
                                    <MenuItems isMobile setMenuOpen={setMenuOpen} />

                                </motion.div>
                            </>
                        )}
                    </AnimatePresence>
                </div>
            </header>
        </>
    );
}

export default Header;